import type { SportUiConfiguration } from "../../types/sportUiConfiguration.ts";

export const defaultsUiConfig: SportUiConfiguration = {
  uniforms: {
    showEntityManageUniforms: true,
    allowFixtureUniformChange: true,
  },
};
